import { CssHelper } from "~/helpers/css_helper"
export class FormHelper {
  static disableForm(button) {
    this.checkoutButton = button
    this.checkoutButtonText = $(button).html()

    var proceedingToCheckoutText = "Proceeding"

    if ($(button).data("loading") != "") {
      proceedingToCheckoutText = $(button).data("loading")
    }

    $(this.checkoutButton).html(`<div class="far fa-spinner-third fa-spin"></div> ${proceedingToCheckoutText}`)
    $(this.checkoutButton).prop("disabled", true)
  }

  static enableForm() {
    $(this.checkoutButton).html(this.checkoutButtonText)
    $(this.checkoutButton).prop("disabled", false)
  }

  static displayFlashError(message) {
    App.displayFlash("danger", message)
    $("html, body").animate({ scrollTop: 0 }, "slow")
  }

  static elementStyles(fontSize) {
    return {
      style: {
        base: {
          fontFamily: CssHelper.getVar("--fonts-family-body", document.querySelector(".application-back")),
          fontSmoothing: "antialiased",
          fontSize: fontSize,
          color: CssHelper.getVar("--h-input-color"),
          "::placeholder": {
            color: CssHelper.getVar("--colors-grey-500"),
          },
          ":focus::placeholder": {
            color: CssHelper.getVar("--colors-grey-400"),
          },
        },
      },
      hidePostalCode: true,
      classes: {
        focus: "focus",
      },
    }
  }
}
